import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getYearList = store => store[NAME].yearList;
export const getPerformanceProcessList = store => store[NAME].performanceProcessList;
export const getCalibrationCommitteeList = store => store[NAME].calibrationCommitteeList;
export const getUnassignedEmployeeList = store => store[NAME].unassignedEmployeeList;
export const getNineBoxDefinition = store => store[NAME].nineBoxDefinition;
export const getIsCalibrationEnabled = store => store[NAME].isCalibrationEnabled;